import Box from '@mui/material/Box';
import { createFileRoute } from '@tanstack/react-router';
import useStore, { selectBatchData } from '../hooks/client/useStore';
import QuickView from '../features/product-trace/QuickView';
import AppHeader from '../features/app-header/AppHeader';

const SearchComponent = () => {
  const batchData = useStore(selectBatchData);
  return (
    <Box>
      <AppHeader />
      <QuickView data={batchData} />
    </Box>
  );
};

export const Route = createFileRoute('/batch')({
  component: SearchComponent,
});
